import { Component, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { PetInsuranceData, PetInsuranceView } from "../../../models";
import { ApiHttpService } from "../../../services/api-http.service";
import { DataStorageService } from "../../../services/data-storage.service";
import { Router } from "@angular/router";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: 'cpf-insurance-card',
  templateUrl: './insurance-card.component.html',
  styleUrls: ['./insurance-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InsuranceCardComponent implements OnDestroy {
  private destroy$ = new Subject<void>();
  @Input() set pet(pet: PetInsuranceData) {
    this.petInfo = pet;
    this.petInsuranceView = {
      full_contract_number: pet.full_contract_number,
      base_number: pet.base_number,
      name: pet.pet_name,
      annualFranchiseOverall: pet.annual_franchise,
      annualFranchiseRemaining: pet.usedFranchise < 0 ? 0 : pet.usedFranchise,
      insuredSumOverall: pet.overall_sum_insured,
      insuredSumRemaining: pet.paidAmount < 0 ? 0 : pet.paidAmount,
      contractStatus: pet.contractStatus,
      species: pet.pet_species
    };

    this.getPetImageUrl();
  }

  petInfo?: PetInsuranceData;
  petInsuranceView?: PetInsuranceView;

  constructor(private apiHttpService: ApiHttpService, private router: Router, private dataStorageService: DataStorageService) {
    this.dataStorageService.petPictureUpdated$.pipe(takeUntil(this.destroy$)).subscribe(baseNumber => {
      if (this.petInsuranceView?.base_number === baseNumber) {
        this.getPetImageUrl();
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async getPetImageUrl() {
    if (!this.petInfo || !this.petInsuranceView) {
      return
    }

    this.petInsuranceView.image = (await this.apiHttpService.getUrlForPetPicture(this.petInsuranceView.base_number)).Location || (this.petInsuranceView.species === 'cat' ? '/assets/cat_icon_placeholder.png' : '/assets/dog_icon_placeholder.png');
  }

  navigateEditPet() {
    this.router.navigate(['calingo', 'pet', 'insurance', 'edit-pet-info'])
  }
}
